// extracted by mini-css-extract-plugin
export default {"wrapper":"SceneHint_wrapper__ktvVa","item":"SceneHint_item__8Lmr5","image":"SceneHint_image__yn4Jk","text":"SceneHint_text__14VVi"};